import { Picture } from '.'
import webp from './img/app.webp'
import fallback from './img/app.png'

export default function ImgApp(props) {
  return <Picture src={webp} fallback={fallback} {...props} />
}
